module.exports = __webpack_public_path__ + "img/pix.0e6d49fe.png";